export default __webpack_public_path__ + "83f0d6c.png";